import { Icon, IconButton, Input, Modal } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import ImageGallery from "react-image-gallery";
import { connect } from "react-redux";
import "../../css/react-image-gallery.css";
import "../../css/serviceAlbum.css";
import { getOriginalImage, isJsonString } from "../../utils/setting";
import { getThumbnaiImage } from "../../utils/storage";
import Dialog from "../dialog";
import { style } from "./style";

// import { Slide } from 'react-slideshow-image';
// Component
// Style

class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      selectImage: "",
      imageDelete: "",
      serviceAlbum: [],

      startIndex: 0,
      showIndex: false,
      showBullets: true,
      infinite: true,
      showThumbnails: false,
      showFullscreenButton: false,
      showGalleryFullscreenButton: false,
      showPlayButton: false,
      showGalleryPlayButton: true,
      showNav: true,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 2000,
      thumbnailPosition: "bottom",

      imageGallery: isJsonString(this.props.imageGallery)
        ? this.getThumnailList(JSON.parse(this.props.imageGallery))
        : Array.isArray(this.props.imageGallery)
        ? this.props.imageGallery
        : [],
      showingIndex: -1,
    };
    this.handleSelectImage = this.handleSelectImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
  }
  getThumnailList = (imageGallery) => {
    if (imageGallery && Array.isArray(imageGallery))
      return imageGallery.map((image, index) => {
        return getThumbnaiImage(image);
      });
    else return [];
  };
  async componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    this.setState({
      imageGallery: isJsonString(nextProps.imageGallery)
        ? this.getThumnailList(JSON.parse(nextProps.imageGallery))
        : Array.isArray(nextProps.imageGallery)
        ? nextProps.imageGallery
        : [],
    });
  }
  handleOpenModal = (url, index) => {
    this.setState({
      openModal: true,
      selectImage: url,
      startIndex: index,
      showingIndex: index,
    });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false, showingIndex: -1 });
  };

  openDialog = (url) => {
    this.setState({ imageDelete: url }, function () {
      this.mDialog.handleDialogOpen();
    });
  };

  async handleSelectImage(e) {
    this.props.handleSelectImage({
      e: e,
      imageGallery: this.state.imageGallery,
    });
  }

  async deleteImage() {
    this.mDialog.handleDialogClose();
    let imageGallery = this.state.imageGallery;
    let position = -1;
    imageGallery.map((image, index) => {
      if (image == this.state.imageDelete) position = index;
    });
    if (position != -1) imageGallery.splice(position, 1);
    this.props.deleteImage({
      imageDelete: this.state.imageDelete,
      imageGallery: imageGallery,
    });
  }

  onSlide = (index) => {
    this.setState({ showingIndex: index });
  };
  getOriginalImage = (allImage, showingIndex) => {
    return allImage.map((e, index) => {
      if (showingIndex === index) return getOriginalImage(e);
    });
  };
  render() {
    const { classes, t } = this.props;
    const { imageGallery = [], showingIndex } = this.state;
    let images = [];
    const modalImage = this.getOriginalImage(imageGallery, showingIndex);
    return (
      <div className={classes.root}>
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("service_ownerspa_servicealbum_cancel")}
          agree={t("service_ownerspa_servicealbum_delete")}
          title={t("service_ownerspa_servicealbum_confirm")}
          content={t("voucher_delete_image_in_gallery")}
          action={this.deleteImage}
        />

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openModal}
          onClose={this.handleCloseModal}
        >
          <ImageGallery
            ref={(i) => (this._imageGallery = i)}
            items={modalImage.map((e) => {
              return {
                original: e,
                thumbnail: e,
              };
            })}
            startIndex={this.state.startIndex}
            lazyLoad={false}
            infinite={this.state.infinite}
            showBullets={this.state.showBullets}
            showFullscreenButton={
              this.state.showFullscreenButton &&
              this.state.showGalleryFullscreenButton
            }
            showPlayButton={
              this.state.showPlayButton && this.state.showGalleryPlayButton
            }
            showThumbnails={this.state.showThumbnails}
            showIndex={this.state.showIndex}
            showNav={this.state.showNav}
            isRTL={this.state.isRTL}
            thumbnailPosition={this.state.thumbnailPosition}
            slideDuration={parseInt(this.state.slideDuration)}
            slideInterval={parseInt(this.state.slideInterval)}
            additionalClass="app-image-gallery"
            onSlide={this.onSlide}
          />
        </Modal>
        <div className={classes.container}>
          <div className={classes.listItem}>
            <IconButton
              className={classes.buttonIcon}
              onClick={() => document.getElementById("add-image").click()}
              aria-label="Add"
            >
              {/* <Icon className={classes.icon} color="primary" >
                                        add_circle
                                    </Icon>    */}
              <CameraAltIcon className={classes.icon} />
            </IconButton>
            <Input
              className={classes.inputImage}
              disableUnderline
              id="add-image"
              type="file"
              margin="none"
              onChange={this.handleSelectImage}
            />
            <div
              className={classes.imageItem}
              style={{ backgroundImage: "url(`/images/noneImage.svg`)" }}
            ></div>
          </div>
          {imageGallery &&
            imageGallery.length > 0 &&
            imageGallery.map((tile, index) => {
              return (
                <div key={`gallery-${index}`} className={classes.container}>
                  <div className={classes.listItem + " list-item-image-album"}>
                    <div className="bg-hover-image-album">
                      <div className="bg-hover-image-album-icon">
                        <IconButton
                          className={classes.buttonHover + " f-left"}
                          onClick={() => this.handleOpenModal(tile, index)}
                          aria-label="Zoom"
                        >
                          <Icon
                            className={classes.iconHover + " fa fa-arrows-alt"}
                            color="inherit"
                          />
                        </IconButton>
                        <IconButton
                          className={classes.buttonHover + " f-right"}
                          onClick={() => this.openDialog(tile)}
                          aria-label="Delete"
                        >
                          <Icon
                            className={classes.iconHover + " fa fa-trash"}
                            color="inherit"
                          />
                        </IconButton>
                      </div>
                    </div>
                    <div
                      className={classes.imageItem}
                      style={{ backgroundImage: "url(" + tile + ")" }}
                    ></div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: true })(Gallery)));
